import React from 'react';

const FontAwesome = () => (	
    <script src="https://kit.fontawesome.com/2c36e9b7b1.js" crossorigin="anonymous"></script>
)

export default FontAwesome;